import produce from "immer"
import type { UserGroupDto } from "../../models"
import type { Licence } from "../licences/licence.types"
import { USER_LOAD_GROUPS, USER_LOAD_LICENCES, USER_SELECT_LICENCE } from "./user.actions"
import type { IUserState, UserActions } from "./user.types"

const userInitialState: IUserState = {}

export function userReducer(currentState: IUserState | undefined, action: UserActions): IUserState {
  const state = currentState ?? userInitialState
  switch (action.type) {
    case USER_LOAD_LICENCES:
      return loadUserLicenceList(state, action.payload as string[])
    case USER_SELECT_LICENCE:
      return loadSelectedLicence(state, action.payload as Licence)
    case USER_LOAD_GROUPS:
      return loadGroups(state, action.payload as UserGroupDto[])
    default:
      return state
  }
}

function loadGroups(currentState: IUserState, groups: UserGroupDto[]): IUserState {
  return produce(currentState, (draftState: IUserState) => {
    draftState.groups = groups
  })
}

function loadUserLicenceList(currentState: IUserState, licences: string[]): IUserState {
  return produce(currentState, (draftState: IUserState) => {
    draftState.licences = licences
  })
}

function loadSelectedLicence(currentState: IUserState, licence: Licence): IUserState {
  return produce(currentState, (draftState: IUserState) => {
    draftState.selectedLicence = licence
  })
}
